export default "__VITE_ASSET__CVA$8eWF__"